(ns practitest.frontend.components.spinners
  (:require
   [reagent.core :as reagent]
   [reagent.dom]))

;; TODO: tweak this one
(def default-delay 300)

;; We want to avoid showing spinner if data was loaded instantly
;; otherwise it will look like annoying flickering
(defn delayed-display
  [delay component]
  (let [local-state (reagent/atom {:visible? false})]
    (reagent/create-class
      {:component-did-mount (fn [_]
                              ;; TODO: calculate delay from start of a fetch, not from mounting
                              (js/setTimeout
                                (fn []
                                  (swap! local-state assoc :visible? true))
                                delay))

       :reagent-render      (fn [_ component]
                              (when (:visible? @local-state)
                                component))})))

;; Must have position: relative/absolute parent !!
(defn overlay-spinner
  [props]
  [delayed-display
   default-delay
   [:<>
    [:div.spinner-overlay]
    [:div.spinner-holder
     [:div.spinner-border (merge {:role "status"}
                                 props)
      [:span.visually-hidden "Loading..."]]]]])

;; Embedded styles for spinner to look correctly without loaded CSS files
(defn overlay-spinner-embedded-styles
  []
  [delayed-display
   default-delay
   [:<>
    ;; Embed animation CSS from bootstrap
    [:style
     "@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: -0.125em;
  border: 0.25em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: 0.75s linear infinite spinner-border;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 0.2em;
}"]

    [:div.spinner-overlay
     {:style {:position         "absolute"
              :top              0
              :right            0
              :width            "100%"
              :height           "100%"
              :background-color "grey"
              :opacity          0.2
              :z-index          9000}}]
    [:div.spinner-holder
     {:style {:display         "flex"
              :align-items     "center"
              :justify-content "center"
              :position        "absolute"
              :top             0
              :right           0
              :width           "100%"
              :height          "100%"
              :z-index         9100}}
     [:div.spinner-border
      {:role  "status"}]]]])

(defn bootstrap-spinner-border
  [props]
  [delayed-display
   default-delay

   [:div.spinner-border (merge {:role "status"}
                               props)
    [:span.visually-hidden "Loading..."]]])

(defn bootstrap-spinner-grow
  [props]
  [delayed-display
   default-delay
   [:div.spinner-grow (merge {:role "status"}
                             props)
    [:span.visually-hidden "Loading..."]]])

(defn inline-spinner-border
  []
  [:span.spinner-border.spinner-border-sm
   {:role "status" :aria-hidden "true"}])

(defn progress-bar
  [progress]
  [delayed-display
   default-delay
   (let [percentage (str progress "%")]
     [:div.progress
      [:div.progress-bar
       {:role  "progressbar"
        :style {:width percentage}}
       percentage]])])

(defn modal-spinner
  "Fullscreen modal spinner.
   Generally, it's a bad idea to have modal spinners, but we need it sometimes while transitioning from MPA to SPA"
  [{:keys [show? body]}]
  (when @show?
    [:div.fullscreen-spinner-backdrop body]))
